import { FiCornerDownRight } from 'react-icons/fi';
import { cn } from '../../utils/helpers';

/**
 * The "replying to …" line above a reply.
 *
 * Replies sit inline in the main conversation, so without this they read as
 * ordinary messages that happen to be out of order. The quote names who is being
 * answered and shows enough of their message to make the exchange followable
 * without opening the thread.
 */
export default function ReplyQuote({ replyTo, onOpen, className }) {
  if (!replyTo) return null;

  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        'group/quote flex items-start gap-1.5 w-full text-left mb-1.5 text-[11px] transition-colors',
        'text-primary/45 hover:text-primary/70',
        className
      )}
      title="Open thread"
    >
      <FiCornerDownRight className="w-3 h-3 mt-[1px] shrink-0" />

      {/* The bar carries the "quoted" meaning on its own, so the line still
          reads as a quote for anyone who cannot make out the icon. */}
      <span
        className="pl-1.5 min-w-0 flex-1 border-l-2 border-primary/15
                   group-hover/quote:border-accent transition-colors"
      >
        <span className="font-medium">{replyTo.senderName}</span>
        {': '}
        {replyTo.deleted ? (
          <span className="italic">message deleted</span>
        ) : (
          /* Rendered as text, never HTML — same rule as the message body. */
          <span className="truncate inline-block max-w-full align-bottom">
            {replyTo.preview}
          </span>
        )}
      </span>
    </button>
  );
}
